import axios from 'axios'

export interface ISummarizeToNotitieResponse {
    content: string
    success: boolean
    message?: string
}

export default class SummarizeToNotitieService {
    summarizeResult(resultaatId: number) {
        return axios.post<ISummarizeToNotitieResponse>(`/api/Frontend/Resultaten/Algemeen/SummarizeToNotitie/${resultaatId}`)
    }
}

export const summarizeToNotitieService = new SummarizeToNotitieService()
